import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=94f6d844&scoped=true&"
import script from "./workflow.vue?vue&type=script&lang=js&"
export * from "./workflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f6d844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94f6d844')) {
      api.createRecord('94f6d844', component.options)
    } else {
      api.reload('94f6d844', component.options)
    }
    module.hot.accept("./workflow.vue?vue&type=template&id=94f6d844&scoped=true&", function () {
      api.rerender('94f6d844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/workflow/workflow/workflow.vue"
export default component.exports